// frontend/src/components/BackToTopButton.js
import React, { useState, useEffect } from 'react';
import './BackToTopButton.css'; // We'll create this CSS next

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.scrollY > 300) { // Show button after scrolling 300px
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top when button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // For a smooth scroll animation
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []); // Empty dependency array means this effect runs once on mount and cleans up on unmount

  return (
    <button
      className={`back-to-top ${isVisible ? 'show' : ''}`} // Add 'show' class when visible
      onClick={scrollToTop}
      title="Go to top"
    >
      <i className="fas fa-arrow-up"></i> {/* Font Awesome Up Arrow Icon */}
    </button>
  );
};

export default BackToTopButton;